var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesarrollo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 705.508,
    height: 471.204,
    viewBox: "0 0 705.508 471.204",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef7a90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24748a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_pair_programming_re_or4x",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_30",
    "data-name": "Elipse 30",
    cx: 21.833,
    cy: 21.833,
    r: 21.833,
    transform: "translate(334.311 36.44)",
    fill: "#fd6584"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_502",
    "data-name": "Trazado 502",
    d: "M643.264,218.738a10.822,10.822,0,0,0-9.134-7.6.874.874,0,0,0-.147,0,1.15,1.15,0,0,0-.18-.041,26.671,26.671,0,0,0-20.908,6.378,19.588,19.588,0,0,0-4.767,6.574,10.563,10.563,0,0,0-8.856-4.317,10.78,10.78,0,0,0-9.649,7.776,1.248,1.248,0,0,0,.564,1.382,5.456,5.456,0,0,0,2.281,1.161c1.807.384,3.63.736,5.454,1.055q5.348.932,10.753,1.513,3.569.38,7.155.605c4.939.311,9.9.384,14.849.229a16.941,16.941,0,0,0,7.048-1.243,10.463,10.463,0,0,0,4.048-3.524A11.894,11.894,0,0,0,643.264,218.738Z",
    transform: "translate(-238.258 -170.803)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_503",
    "data-name": "Trazado 503",
    d: "M588.231,257.038a11.165,11.165,0,0,0-.458-2.7,10.842,10.842,0,0,0-9.142-7.6.794.794,0,0,0-.139,0,1.531,1.531,0,0,0-.188-.041,27.141,27.141,0,0,0-12.012,1.235c-5.936,1.987-11.145,5.993-13.655,11.717a10.567,10.567,0,0,0-8.864-4.317,10.78,10.78,0,0,0-9.649,7.776,1.272,1.272,0,0,0,.564,1.382,5.507,5.507,0,0,0,2.281,1.161c1.815.384,3.63.736,5.462,1.055q5.348.932,10.744,1.513a159.589,159.589,0,0,0,22.012.834,16.965,16.965,0,0,0,7.048-1.243,10.442,10.442,0,0,0,4.039-3.524A11.663,11.663,0,0,0,588.231,257.038Z",
    transform: "translate(-228.14 -177.295)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_506",
    "data-name": "Trazado 506",
    d: "M876.551,610.95H792.022a137.311,137.311,0,0,1,.122-20.326c3.378-41.778,26.107-81.578,60.4-105.677-4.381,15.61-2.13,31.128,2.434,46.707-.639.213-1.278.4-1.856.639a37.8,37.8,0,0,0-12.506,7.668c-1,.943-2.069,2.313-1.552,3.621.456,1.1,1.826,1.461,3.012,1.7,2.86.548,5.721,1.1,8.55,1.613,2.282.456,4.564.882,6.846,1.339,1.065.183,2.13.4,3.2.609.152.365.243.7.4,1.035,5.355,14.758,11.2,29.637,13.936,44.76a104.452,104.452,0,0,1,1.4,11.471C876.49,607.725,876.551,609.338,876.551,610.95Z",
    transform: "translate(-275.109 -220.769)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_508",
    "data-name": "Trazado 508",
    d: "M394.186,571.023c-14.362,8.733-23.491,22.243-30.945,37.366a38.223,38.223,0,0,0-17.375,9.128c-1.035.944-2.1,2.313-1.552,3.621.457,1.1,1.826,1.461,3.012,1.7,2.83.548,5.72,1.1,8.55,1.613-.274.639-.548,1.308-.821,1.948H260.12a134.256,134.256,0,0,1,14.271-16.309c1.126-1.126,2.282-2.191,3.469-3.286a141.992,141.992,0,0,1,41.078-25.925,144.512,144.512,0,0,1,75.249-9.859Z",
    transform: "translate(-178.189 -236.222)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_510",
    "data-name": "Trazado 510",
    d: "M664.33,519.163l75.529,6.7.809.074V203.662l-.809-.564a235.758,235.758,0,0,0-50.7-26.934L685.3,229.395l-.351,4.873-3.819,52.789L679.948,303.3,664.469,517.283Z",
    transform: "translate(-251.886 -164.471)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_511",
    "data-name": "Trazado 511",
    d: "M435.539,197.083c-.54.343-1.079.687-1.619,1.047V525.364l1.619-.147,74.711-6.631-.139-1.881L494.633,302.718l-1.177-16.239-3.819-52.789-.352-4.873-4.048-55.823a235.237,235.237,0,0,0-49.7,24.089Z",
    transform: "translate(-209.876 -163.893)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_512",
    "data-name": "Trazado 512",
    d: "M433.2,203.5c-1.087.7-2.175,1.423-3.246,2.15V535.2c0,8.234,4.881,15.135,11.407,16.893a12.464,12.464,0,0,0,3.271.433H687.314a12.365,12.365,0,0,0,3.262-.433,13.95,13.95,0,0,0,6.362-3.81,18.74,18.74,0,0,0,5.053-13.083V211.383c-1.341-.989-2.69-1.971-4.056-2.927l-.81-.564V535.2a13.169,13.169,0,0,1-.376,3.148c-1.153,4.865-4.955,8.43-9.436,8.43H444.627c-5.413,0-9.812-5.192-9.812-11.578V202.454C434.276,202.8,433.736,203.141,433.2,203.5Z",
    transform: "translate(-209.153 -169.264)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_180",
    "data-name": "Rect\\xE1ngulo 180",
    width: 267.177,
    height: 4.873,
    transform: "translate(223.228 64.927)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_513",
    "data-name": "Trazado 513",
    d: "M658.513,165c-1.619-.4-3.238-.777-4.873-1.128V296.182h4.873Z",
    transform: "translate(-249.937 -162.23)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_514",
    "data-name": "Trazado 514",
    d: "M537.873,161.864c-1.627.3-3.254.613-4.873.949v133h4.873Z",
    transform: "translate(-227.941 -161.864)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_515",
    "data-name": "Trazado 515",
    d: "M368.86,615.266a21.839,21.839,0,0,0,1.578,8.16,20.886,20.886,0,0,0,1.431,2.911,22.147,22.147,0,0,0,2.469,3.418A21.881,21.881,0,0,0,390.79,637.2H710.755a21.93,21.93,0,1,0,0-43.86H390.79A21.952,21.952,0,0,0,368.86,615.266Z",
    transform: "translate(-198.015 -240.533)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_181",
    "data-name": "Rect\\xE1ngulo 181",
    width: 265.554,
    height: 16.242,
    transform: "translate(488.782 138.827) rotate(180)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_516",
    "data-name": "Trazado 516",
    d: "M0,0H22.739a8.933,8.933,0,0,1-8.933,8.933H8.933A8.933,8.933,0,0,1,0,0H0Z",
    transform: "translate(367.374 126.645) rotate(180)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_517",
    "data-name": "Trazado 517",
    d: "M159.92,635.474a236.33,236.33,0,0,0,22.993,23.672H842.435a236.319,236.319,0,0,0,22.993-23.672Z",
    transform: "translate(-159.92 -248.214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_518",
    "data-name": "Trazado 518",
    d: "M556.61,538.033v83.861h58.75V538.033a2.82,2.82,0,0,0-1.987-2.7,2.6,2.6,0,0,0-.842-.131H559.447a2.832,2.832,0,0,0-2.837,2.829Zm22.928,28.815a6.272,6.272,0,1,1,12.543,0v9.73a6.272,6.272,0,0,1-12.543,0Z",
    transform: "translate(-232.246 -229.932)",
    fill: "#221e1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_519",
    "data-name": "Trazado 519",
    d: "M556.39,637.944v8.087a1.591,1.591,0,0,0,1.578,1.586h55.954a1.586,1.586,0,0,0,1.578-1.586v-8.087Z",
    transform: "translate(-232.206 -248.665)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_520",
    "data-name": "Trazado 520",
    d: "M443.58,382.5V535.623a7.365,7.365,0,0,0,7.359,7.359H677.844a7.365,7.365,0,0,0,7.359-7.359V382.5a7.369,7.369,0,0,0-7.359-7.351H450.939A7.368,7.368,0,0,0,443.58,382.5Z",
    transform: "translate(-211.638 -200.752)",
    fill: "#221e1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_521",
    "data-name": "Trazado 521",
    d: "M450.09,385.6V534.919a3.94,3.94,0,0,0,3.933,3.933h223.12a3.94,3.94,0,0,0,3.933-3.933V385.6a3.942,3.942,0,0,0-3.933-3.941H454.023A3.942,3.942,0,0,0,450.09,385.6Z",
    transform: "translate(-212.825 -201.937)",
    fill: "#ef7a90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_522",
    "data-name": "Trazado 522",
    d: "M505.608,649.036a2.412,2.412,0,0,0,1.9.908H640.246A2.443,2.443,0,0,0,642.634,647l-2.06-9.787a2.447,2.447,0,0,0-1.521-1.774,2.364,2.364,0,0,0-.867-.164H509.557a2.361,2.361,0,0,0-.867.164,2.446,2.446,0,0,0-1.521,1.774L505.109,647A2.441,2.441,0,0,0,505.608,649.036Z",
    transform: "translate(-222.847 -248.178)",
    fill: "#221e1d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_189",
    "data-name": "Rect\\xE1ngulo 189",
    width: 4.088,
    height: 2.453,
    rx: 0.488,
    transform: "translate(357.159 391.312) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_190",
    "data-name": "Rect\\xE1ngulo 190",
    width: 4.088,
    height: 2.453,
    rx: 0.488,
    transform: "translate(348.982 391.312) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_191",
    "data-name": "Rect\\xE1ngulo 191",
    width: 4.088,
    height: 2.453,
    rx: 0.488,
    transform: "translate(340.805 391.312) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_192",
    "data-name": "Rect\\xE1ngulo 192",
    width: 4.088,
    height: 2.453,
    rx: 0.488,
    transform: "translate(332.628 391.312) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_193",
    "data-name": "Rect\\xE1ngulo 193",
    width: 4.088,
    height: 2.453,
    rx: 0.488,
    transform: "translate(324.452 391.312) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_206",
    "data-name": "Rect\\xE1ngulo 206",
    width: 4.088,
    height: 2.453,
    rx: 0.488,
    transform: "translate(349.079 395.4) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_207",
    "data-name": "Rect\\xE1ngulo 207",
    width: 4.088,
    height: 2.453,
    rx: 0.488,
    transform: "translate(340.902 395.4) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_208",
    "data-name": "Rect\\xE1ngulo 208",
    width: 4.088,
    height: 2.453,
    rx: 0.488,
    transform: "translate(332.725 395.4) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_209",
    "data-name": "Rect\\xE1ngulo 209",
    width: 4.088,
    height: 2.453,
    rx: 0.488,
    transform: "translate(324.548 395.4) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_515",
    "data-name": "Grupo 515",
    transform: "translate(287.656 388.86)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_182",
    "data-name": "Rect\\xE1ngulo 182",
    width: 4.088,
    height: 2.453,
    rx: 0.488,
    transform: "translate(126.74 2.453) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_183",
    "data-name": "Rect\\xE1ngulo 183",
    width: 4.088,
    height: 2.453,
    rx: 0.488,
    transform: "translate(118.563 2.453) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_184",
    "data-name": "Rect\\xE1ngulo 184",
    width: 4.088,
    height: 2.453,
    rx: 0.488,
    transform: "translate(110.386 2.453) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_185",
    "data-name": "Rect\\xE1ngulo 185",
    width: 4.088,
    height: 2.453,
    rx: 0.488,
    transform: "translate(102.21 2.453) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_186",
    "data-name": "Rect\\xE1ngulo 186",
    width: 4.088,
    height: 2.453,
    rx: 0.488,
    transform: "translate(94.033 2.453) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_187",
    "data-name": "Rect\\xE1ngulo 187",
    width: 4.088,
    height: 2.453,
    rx: 0.488,
    transform: "translate(85.856 2.453) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_188",
    "data-name": "Rect\\xE1ngulo 188",
    width: 4.088,
    height: 2.453,
    rx: 0.488,
    transform: "translate(77.679 2.453) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_194",
    "data-name": "Rect\\xE1ngulo 194",
    width: 4.088,
    height: 2.453,
    rx: 0.488,
    transform: "translate(28.619 2.453) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_195",
    "data-name": "Rect\\xE1ngulo 195",
    width: 4.088,
    height: 2.453,
    rx: 0.488,
    transform: "translate(20.442 2.453) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_196",
    "data-name": "Rect\\xE1ngulo 196",
    width: 4.088,
    height: 2.453,
    rx: 0.488,
    transform: "translate(12.265 2.453) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_197",
    "data-name": "Rect\\xE1ngulo 197",
    width: 4.088,
    height: 2.453,
    rx: 0.488,
    transform: "translate(4.088 2.453) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_198",
    "data-name": "Rect\\xE1ngulo 198",
    width: 4.088,
    height: 2.453,
    rx: 0.488,
    transform: "translate(126.836 6.541) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_199",
    "data-name": "Rect\\xE1ngulo 199",
    width: 4.088,
    height: 2.453,
    rx: 0.488,
    transform: "translate(118.66 6.541) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_200",
    "data-name": "Rect\\xE1ngulo 200",
    width: 4.088,
    height: 2.453,
    rx: 0.488,
    transform: "translate(110.483 6.541) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_201",
    "data-name": "Rect\\xE1ngulo 201",
    width: 4.088,
    height: 2.453,
    rx: 0.488,
    transform: "translate(102.306 6.541) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_202",
    "data-name": "Rect\\xE1ngulo 202",
    width: 4.088,
    height: 2.453,
    rx: 0.488,
    transform: "translate(94.129 6.541) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_203",
    "data-name": "Rect\\xE1ngulo 203",
    width: 4.088,
    height: 2.453,
    rx: 0.488,
    transform: "translate(85.953 6.541) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_204",
    "data-name": "Rect\\xE1ngulo 204",
    width: 4.088,
    height: 2.453,
    rx: 0.488,
    transform: "translate(77.776 6.541) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_205",
    "data-name": "Rect\\xE1ngulo 205",
    width: 4.088,
    height: 2.453,
    rx: 0.488,
    transform: "translate(69.599 6.541) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_210",
    "data-name": "Rect\\xE1ngulo 210",
    width: 4.088,
    height: 2.453,
    rx: 0.488,
    transform: "translate(28.715 6.541) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_211",
    "data-name": "Rect\\xE1ngulo 211",
    width: 4.088,
    height: 2.453,
    rx: 0.488,
    transform: "translate(20.539 6.541) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_212",
    "data-name": "Rect\\xE1ngulo 212",
    width: 4.088,
    height: 2.453,
    rx: 0.488,
    transform: "translate(12.362 6.541) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_213",
    "data-name": "Rect\\xE1ngulo 213",
    width: 4.088,
    height: 2.453,
    rx: 0.488,
    transform: "translate(4.185 6.541) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_214",
    "data-name": "Rect\\xE1ngulo 214",
    width: 32.707,
    height: 2.453,
    rx: 0.488,
    transform: "translate(87.588 11.447) rotate(180)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_523",
    "data-name": "Trazado 523",
    d: "M468.427,406.441H677.2a.83.83,0,1,0,0-1.661H468.427a.83.83,0,1,0,0,1.661Z",
    transform: "translate(-216.017 -206.153)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_31",
    "data-name": "Elipse 31",
    cx: 4.866,
    cy: 4.974,
    rx: 4.866,
    ry: 4.974,
    transform: "translate(442.105 184.44)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_32",
    "data-name": "Elipse 32",
    cx: 4.866,
    cy: 4.974,
    rx: 4.866,
    ry: 4.974,
    transform: "translate(425.297 184.44)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_33",
    "data-name": "Elipse 33",
    cx: 4.866,
    cy: 4.974,
    rx: 4.866,
    ry: 4.974,
    transform: "translate(408.489 184.44)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_524",
    "data-name": "Trazado 524",
    d: "M479.9,389.842a.9.9,0,0,0,.891.9h11.938a.9.9,0,0,0,0-1.807H480.791A.9.9,0,0,0,479.9,389.842Z",
    transform: "translate(-218.26 -203.264)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_525",
    "data-name": "Trazado 525",
    d: "M479.9,393.992a.9.9,0,0,0,.891.9h11.938a.9.9,0,1,0,0-1.807H480.791A.9.9,0,0,0,479.9,393.992Z",
    transform: "translate(-218.26 -204.021)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_526",
    "data-name": "Trazado 526",
    d: "M479.9,398.133a.9.9,0,0,0,.891.908h11.938a.9.9,0,0,0,0-1.807H480.791A.9.9,0,0,0,479.9,398.133Z",
    transform: "translate(-218.26 -204.777)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_215",
    "data-name": "Rect\\xE1ngulo 215",
    width: 8.999,
    height: 4.71,
    rx: 2.355,
    transform: "translate(258.685 219.581)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_216",
    "data-name": "Rect\\xE1ngulo 216",
    width: 8.999,
    height: 4.71,
    rx: 2.355,
    transform: "translate(307.746 219.581)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_217",
    "data-name": "Rect\\xE1ngulo 217",
    width: 8.999,
    height: 4.71,
    rx: 2.355,
    transform: "translate(321.646 219.581)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_218",
    "data-name": "Rect\\xE1ngulo 218",
    width: 31.371,
    height: 4.71,
    rx: 2.355,
    transform: "translate(272.03 219.189)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_219",
    "data-name": "Rect\\xE1ngulo 219",
    width: 31.371,
    height: 4.71,
    rx: 2.355,
    transform: "translate(337.444 219.189)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_220",
    "data-name": "Rect\\xE1ngulo 220",
    width: 8.999,
    height: 4.71,
    rx: 2.355,
    transform: "translate(271.768 230.211)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_221",
    "data-name": "Rect\\xE1ngulo 221",
    width: 8.999,
    height: 4.71,
    rx: 2.355,
    transform: "translate(320.828 230.211)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_222",
    "data-name": "Rect\\xE1ngulo 222",
    width: 8.999,
    height: 4.71,
    rx: 2.355,
    transform: "translate(334.729 230.211)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_223",
    "data-name": "Rect\\xE1ngulo 223",
    width: 31.371,
    height: 4.71,
    rx: 2.355,
    transform: "translate(285.112 229.819)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_224",
    "data-name": "Rect\\xE1ngulo 224",
    width: 31.371,
    height: 4.71,
    rx: 2.355,
    transform: "translate(350.527 229.819)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_225",
    "data-name": "Rect\\xE1ngulo 225",
    width: 8.999,
    height: 4.71,
    rx: 2.355,
    transform: "translate(284.851 240.841)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_226",
    "data-name": "Rect\\xE1ngulo 226",
    width: 8.999,
    height: 4.71,
    rx: 2.355,
    transform: "translate(333.911 240.841)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_227",
    "data-name": "Rect\\xE1ngulo 227",
    width: 8.999,
    height: 4.71,
    rx: 2.355,
    transform: "translate(347.812 240.841)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_228",
    "data-name": "Rect\\xE1ngulo 228",
    width: 31.371,
    height: 4.71,
    rx: 2.355,
    transform: "translate(298.195 240.448)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_229",
    "data-name": "Rect\\xE1ngulo 229",
    width: 31.371,
    height: 4.71,
    rx: 2.355,
    transform: "translate(363.609 240.448)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_230",
    "data-name": "Rect\\xE1ngulo 230",
    width: 8.999,
    height: 4.71,
    rx: 2.355,
    transform: "translate(297.934 251.471)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_231",
    "data-name": "Rect\\xE1ngulo 231",
    width: 8.999,
    height: 4.71,
    rx: 2.355,
    transform: "translate(346.994 251.471)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_232",
    "data-name": "Rect\\xE1ngulo 232",
    width: 8.999,
    height: 4.71,
    rx: 2.355,
    transform: "translate(360.895 251.471)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_233",
    "data-name": "Rect\\xE1ngulo 233",
    width: 31.371,
    height: 4.71,
    rx: 2.355,
    transform: "translate(311.278 251.078)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_234",
    "data-name": "Rect\\xE1ngulo 234",
    width: 8.999,
    height: 4.71,
    rx: 2.355,
    transform: "translate(307.746 293.74)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_235",
    "data-name": "Rect\\xE1ngulo 235",
    width: 8.999,
    height: 4.71,
    rx: 2.355,
    transform: "translate(321.646 293.74)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_236",
    "data-name": "Rect\\xE1ngulo 236",
    width: 31.371,
    height: 4.71,
    rx: 2.355,
    transform: "translate(337.444 294.132)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_237",
    "data-name": "Rect\\xE1ngulo 237",
    width: 8.999,
    height: 4.71,
    rx: 2.355,
    transform: "translate(258.685 293.74)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_238",
    "data-name": "Rect\\xE1ngulo 238",
    width: 31.371,
    height: 4.71,
    rx: 2.355,
    transform: "translate(272.03 294.132)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_239",
    "data-name": "Rect\\xE1ngulo 239",
    width: 8.999,
    height: 4.71,
    rx: 2.355,
    transform: "translate(271.768 283.11)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_240",
    "data-name": "Rect\\xE1ngulo 240",
    width: 8.999,
    height: 4.71,
    rx: 2.355,
    transform: "translate(320.828 283.11)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_241",
    "data-name": "Rect\\xE1ngulo 241",
    width: 8.999,
    height: 4.71,
    rx: 2.355,
    transform: "translate(334.729 283.11)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_242",
    "data-name": "Rect\\xE1ngulo 242",
    width: 31.371,
    height: 4.71,
    rx: 2.355,
    transform: "translate(285.112 283.502)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_243",
    "data-name": "Rect\\xE1ngulo 243",
    width: 8.999,
    height: 4.71,
    rx: 2.355,
    transform: "translate(284.851 272.48)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_244",
    "data-name": "Rect\\xE1ngulo 244",
    width: 8.999,
    height: 4.71,
    rx: 2.355,
    transform: "translate(333.911 272.48)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_245",
    "data-name": "Rect\\xE1ngulo 245",
    width: 8.999,
    height: 4.71,
    rx: 2.355,
    transform: "translate(347.812 272.48)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_246",
    "data-name": "Rect\\xE1ngulo 246",
    width: 31.371,
    height: 4.71,
    rx: 2.355,
    transform: "translate(298.195 272.873)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_247",
    "data-name": "Rect\\xE1ngulo 247",
    width: 8.999,
    height: 4.71,
    rx: 2.355,
    transform: "translate(297.934 261.85)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_248",
    "data-name": "Rect\\xE1ngulo 248",
    width: 8.999,
    height: 4.71,
    rx: 2.355,
    transform: "translate(346.994 261.85)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_249",
    "data-name": "Rect\\xE1ngulo 249",
    width: 8.999,
    height: 4.71,
    rx: 2.355,
    transform: "translate(360.895 261.85)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_250",
    "data-name": "Rect\\xE1ngulo 250",
    width: 31.371,
    height: 4.71,
    rx: 2.355,
    transform: "translate(311.278 262.243)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_527",
    "data-name": "Trazado 527",
    d: "M463.192,672.883c-.18.09-.36.18-.54.262q-1.7.846-3.434,1.668-5.176,2.465-10.483,4.685a233.43,233.43,0,0,1-28.594,9.837c-1.635-10.2-3.222-34.244-4.742-51.931-.286-3.328-.572-6.427-.859-9.166a79.446,79.446,0,0,0-1.545-10.7,3.563,3.563,0,0,0-.319-.793c.155,1.415.319,5.634.474,11.488.082,2.739.155,5.838.237,9.166.384,17.024.785,40.189,1.186,53.378-1.137.278-2.281.556-3.426.818-.72.172-1.447.335-2.175.491-.883.2-1.766.392-2.649.572q-1.386.294-2.772.564a237.188,237.188,0,0,1-45.839,4.448c-1.022,0-2.036-.008-3.058-.016-.311,0-.621-.008-.94-.016-.9-.016-1.832-.033-2.78-.057a235.973,235.973,0,0,1-53.836-7.76l.711-52.421.123-9.166.049-3.475a12.415,12.415,0,0,0-.72,3.475c-.286,2.232-.581,5.4-.875,9.166-1.12,14.522-2.273,37.948-3.467,51.277-14.138-4.023-24.473-7.695-37.392-14.154-.5-.245-1.006-.5-1.5-.752.09-.63.188-1.259.278-1.905,1.464-10.172-.262-23.41,1.357-34.465,1.235-8.528,2.51-16.721,3.794-23.672,1.554-8.365,3.132-14.939,4.693-18.136,1.8-3.688,3.6-7.318,5.339-10.793L271.7,580.4c.392-.777.785-1.545,1.169-2.3,1.75-3.426,3.4-6.591,4.914-9.4,1.063-1.97,2.044-3.753,2.944-5.315,1.055-1.84,1.987-3.36,2.756-4.513a45.223,45.223,0,0,1,23.942-18.161l.245-.065.237.1.27.123,15.585-5.7,6.959-16.754,35.741-2.2,5.773,4.391,2.952,2.249,3.148,2.4,5.789,4.407,1.643.507,2.445.753,16.722,5.135.172-.074.245.065a45.111,45.111,0,0,1,22.372,15.945c.556.72,1.071,1.464,1.57,2.216,1.357,2.012,3.189,5.192,5.348,9.182.891,1.644,1.832,3.426,2.821,5.315.6,1.137,5.748,17.212,10.761,33.631,4.685,15.372,9.248,31.047,9.845,35.07.106.744.221,1.5.327,2.24.679,4.652,1.349,9.338,2,13.909.957,6.779,1.889,13.32,2.78,19.167C463.175,672.777,463.184,672.826,463.192,672.883Z",
    transform: "translate(-177.077 -226.471)",
    fill: "#221e1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_528",
    "data-name": "Trazado 528",
    d: "M300.673,467.587l-6.948-26.813-6.135,23.137Z",
    transform: "translate(-52.434 -80.363)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_534",
    "data-name": "Trazado 534",
    d: "M898.429,673.772c-.5.254-1.006.507-1.5.752-12.919,6.46-23.255,10.131-37.392,14.154-1.194-13.328-2.347-36.755-3.467-51.276-.294-3.769-.589-6.934-.875-9.166a12.428,12.428,0,0,0-.719-3.475l.049,3.475.123,9.166.711,52.421a235.972,235.972,0,0,1-53.836,7.76c-.949.025-1.881.041-2.78.057-.319.008-.63.016-.94.016-1.022.008-2.036.016-3.058.016a236.536,236.536,0,0,1-56.861-6.893c.4-13.189.8-36.354,1.185-53.378.082-3.328.155-6.427.237-9.166.155-5.854.319-10.074.474-11.488a3.561,3.561,0,0,0-.319.793,79.4,79.4,0,0,0-1.545,10.7c-.286,2.739-.573,5.838-.859,9.166-1.521,17.686-3.107,41.734-4.743,51.931a233.454,233.454,0,0,1-28.594-9.837q-7.359-3.066-14.457-6.615c.9-5.887,1.84-12.486,2.8-19.33.753-5.307,1.529-10.761,2.322-16.149,1.226-8.324,42.9-98.211,52.716-101.359l.245-.066.172.074,16.722-5.135,2.445-.752,1.643-.507,5.789-4.407,3.148-2.4,2.952-2.249,5.773-4.391,35.741,2.2,6.958,16.754,15.585,5.7.27-.123.237-.1.246.065a45.223,45.223,0,0,1,23.942,18.161c.768,1.153,1.7,2.674,2.756,4.513.9,1.562,1.881,3.344,2.944,5.315,1.513,2.8,3.164,5.969,4.914,9.4.384.752.777,1.521,1.169,2.3q1.092,2.159,2.216,4.407c1.742,3.475,3.54,7.106,5.34,10.793,1.562,3.2,3.14,9.771,4.693,18.136,1.284,6.95,2.559,15.143,3.794,23.672,1.619,11.055-.106,24.293,1.357,34.465C898.241,672.513,898.339,673.142,898.429,673.772Z",
    transform: "translate(-256.431 -226.47)",
    fill: "#221e1d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_34",
    "data-name": "Elipse 34",
    cx: 41.568,
    cy: 41.568,
    r: 41.568,
    transform: "translate(495.608 200.594)",
    fill: "#eee6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_535",
    "data-name": "Trazado 535",
    d: "M575.659,467.587l6.948-26.813,6.135,23.137Z",
    transform: "translate(-104.956 -80.363)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_536",
    "data-name": "Trazado 536",
    d: "M909.4,612.7c-2.486,34.244.09,49.322-13.631,77.557a234.006,234.006,0,0,1-38.856,14.9q-2.085.589-4.178,1.145a235.965,235.965,0,0,1-53.836,7.76c-.948.024-1.881.041-2.78.057-.319.008-.63.016-.94.016-1.022.008-2.036.016-3.058.016a236.54,236.54,0,0,1-56.861-6.893q-2.8-.687-5.568-1.447a233.43,233.43,0,0,1-28.594-9.837q-7.359-3.067-14.457-6.615c-1.071-.54-2.142-1.079-3.2-1.635-5.421-9.534-8.5-21.129-8.569-35.062C678.622,628.656,901.1,592,909.4,612.7Z",
    transform: "translate(-253.807 -242.949)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_537",
    "data-name": "Trazado 537",
    d: "M909.484,618.405c.127-2.12.269-4.31.435-6.59-8.291-20.7-230.773,15.953-234.526,39.96.01,2.2.1,4.337.263,6.422C684.744,634.5,896.1,599.663,909.484,618.405Z",
    transform: "translate(-253.903 -242.787)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_538",
    "data-name": "Trazado 538",
    d: "M660.963,597.391l18.262-9.131-15.218-41.088L660,526.45a15.668,15.668,0,0,0-25.578-8.919h0a15.668,15.668,0,0,0-2.038,21.683l14.888,18.609Z",
    transform: "translate(-245.434 -226.023)",
    fill: "#eee6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_539",
    "data-name": "Trazado 539",
    d: "M685.007,584.922,660.658,597.1,679.136,655A25.329,25.329,0,0,0,697.4,671.934h0a25.329,25.329,0,0,0,27.586-11.609l49-83.987a25.856,25.856,0,0,0-8.337-35.146h0a25.855,25.855,0,0,0-37.037,10.438L698.7,615.358Z",
    transform: "translate(-251.216 -230.293)",
    fill: "#221e1d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_35",
    "data-name": "Elipse 35",
    cx: 45.737,
    cy: 45.737,
    r: 45.737,
    transform: "translate(125.573 189.388)",
    fill: "#eee6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_540",
    "data-name": "Trazado 540",
    d: "M312.782,404.754c3.719-5.012,9.064-8.576,13.152-13.291,2.243-2.587,4.106-5.519,6.628-7.835,4.686-4.3,11.238-6.067,17.6-6.286a44.4,44.4,0,0,1,36.249,17.2l9.97-5.846,3.939,10.368a6.043,6.043,0,0,1,9.21,7.562c.791-2.444,4.415-2.963,6.413-1.348s2.533,4.487,2.207,7.035a14.162,14.162,0,0,1-10.683,11.714c-4.337.966-9.385-.049-12.856,2.725-2.783,2.224-3.623,6.273-6.463,8.423-3.5,2.65-8.446,1.424-12.8,2.01-7.611,1.025-13.638,8.809-12.723,16.434a19.055,19.055,0,0,0-2.975-6.836c-1.563-1.954-4.2-3.276-6.593-2.558-3.962,1.188-4.611,6.589-3.65,10.612,2.547,10.671,12.2,27.919,12.2,27.919-12.533,4.944-27.465.269-37.135-9.112s-14.706-22.665-16.9-35.958C305.71,426.415,305.974,413.93,312.782,404.754Z",
    transform: "translate(-186.66 -201.148)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_541",
    "data-name": "Trazado 541",
    d: "M858.134,468.665c8.7-19.95,3.772-38.308-6.836-48.047v-.008c-4.17-9.346-9.714-16.558-16.059-18.25-3.066-1.971-6.043-4.285-9.346-5.462a12.174,12.174,0,0,0-9.551.434l-1.684-.45c-1.431-3.655-3.107-3.729-4.972-1.325-7.179-3.344-13.647-4.841-19.4-4.841-18.774,0-29.878,15.9-32.821,35.111l15.691,4.178,5.454-8.692-2.518,9.477,8.659,2.3c13.181,17.163-2.592,56.755-22.584,78.783q7.139-1.975,14.219-3.336l17.155-25.152-10.63,22.9c5.519-.81,12.56-.033,20.254,1.529,2.592-3.385,3.957-7.9,2.616-11.922a45.581,45.581,0,0,1,4.481,13.516c16.239,3.966,38.39,6,50.328,7.506C870.233,513.759,870.259,478.2,858.134,468.665Z",
    transform: "translate(-268.866 -203.589)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_542",
    "data-name": "Trazado 542",
    d: "M878.914,398.976c6.374,14.271-6.487,20.409-18.268,20.236-10.646-.157-19.693-7.635-20.236-18.268a19.277,19.277,0,0,1,18.268-20.236C869.31,380.164,874.573,389.255,878.914,398.976Z",
    transform: "translate(-283.984 -201.76)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_543",
    "data-name": "Trazado 543",
    d: "M523.561,672.855l-10.5-17.511,34.908-26.483,14.514-15.324a15.668,15.668,0,0,1,26.366,6.217h0a15.668,15.668,0,0,1-9.929,19.384l-22.553,7.7Z",
    transform: "translate(-224.306 -243.322)",
    fill: "#eee6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_544",
    "data-name": "Trazado 544",
    d: "M515.508,663.377,499.162,677l-4.407,3.671-.515.425q-1.7.846-3.434,1.668-5.176,2.465-10.483,4.685a233.387,233.387,0,0,1-28.594,9.837q-2.772.761-5.568,1.447c-1.137.278-2.281.556-3.426.818-.719.172-1.447.335-2.175.491-.883.2-1.766.392-2.649.572q-1.386.294-2.772.564a25.318,25.318,0,0,1-7.866-18.348c0-.221,0-.45.008-.679l2.625-67.319,1.161-29.837a25.853,25.853,0,0,1,25.912-25.168c.785,0,1.562.041,2.33.115.556.72,1.071,1.464,1.57,2.216,1.357,2.012,3.189,5.192,5.347,9.182.891,1.644,1.832,3.426,2.821,5.315.6,1.137,5.748,17.212,10.761,33.631L477.6,627.431l-3.99,30.908L489.98,647.6l11.529-7.572,1.366,2.281,3.557,5.936,6.868,11.447Z",
    transform: "translate(-208.665 -234.422)",
    fill: "#221e1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_545",
    "data-name": "Trazado 545",
    d: "M471.928,652.665c-.008,1.39-.041,2.756-.114,4.1a79.53,79.53,0,0,1-1.292,11.088,64.718,64.718,0,0,1-5.977,17.67c-.376.744-.777,1.48-1.186,2.2-1.055.556-2.126,1.1-3.2,1.635-.18.09-.36.18-.54.262q-6.832,3.4-13.917,6.353a233.386,233.386,0,0,1-28.594,9.837q-2.772.761-5.568,1.447-5.458,1.349-11.022,2.445a237.178,237.178,0,0,1-45.839,4.448c-1.022,0-2.036-.008-3.058-.016-.311,0-.621-.008-.94-.016-.9-.016-1.832-.033-2.78-.057a235.971,235.971,0,0,1-53.836-7.76q-2.1-.552-4.178-1.145a233.986,233.986,0,0,1-38.856-14.9c-13.721-28.234-11.145-43.312-13.631-77.557,5.1-12.748,91.424-3.745,157.885,10.654a468.982,468.982,0,0,1,47.7,12.6c13.524,4.522,23.328,9.117,27.171,13.435a6.491,6.491,0,0,1,1.774,3.271Z",
    transform: "translate(-174.047 -242.95)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_546",
    "data-name": "Trazado 546",
    d: "M237.311,618.405c-.127-2.12-.269-4.31-.434-6.59,8.291-20.7,230.773,15.953,234.526,39.96-.01,2.2-.1,4.337-.263,6.422C462.051,634.5,250.69,599.663,237.311,618.405Z",
    transform: "translate(-173.951 -242.787)",
    opacity: 0.2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesarrollo);
export default __webpack_public_path__ + "static/media/desarrollo.e378051aa4e7cfac62cbd4b6678feba8.svg";
export { ForwardRef as ReactComponent };